module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__04-c5e8c8c3475ec1eac0e872eb737ba78f.jpg";